































































import {Vue, Component, Watch} from 'vue-property-decorator';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';
import lang2d from '../../../utils/lang/lang-2d.js';
import { local } from '@/dv-pure-render/force-graph/lib/d3.v4.13.0.js';
import request from '../../../services/index';

@Component({components: {}})
export default class BrainContent extends Vue {
    searchData = SearchStore.state;
    detailData = DetailStore.state;

    lang:any = lang2d;
    placeholder = this.lang.searchPlaceholder;
    searchValue = '';
    inputLock = false;
    cityInputLock = false;
    cityArr = [];
    showlocalHistory = false;
    showCitySelect = false;
    showSearchSuggest = false;
    cur_line = null;

    get historyList() {return this.searchData.historyList}

    //城市搜索
    onSearchCityFocus() {
        this.showCitySelect = true;
    }
    onSearchCityInput (e) {!this.cityInputLock && this.cityInput(e.target.value);}
    onSearchCityCompositionstart (e) {this.cityInputLock = true;}
    onSearchCityCompositionend (e) {this.cityInputLock = false;this.cityInput(e.target.value);}
    async cityInput (str) {
        try {
            SearchStore.changeFilterCity(str);
            let url = `/brain-api/v1/searchCity?cityPinyin=${str}&inputMethod=0`;
            let res = await request({
                path: url,
                method: 'get',
                params: {}
            });
            this.cityArr = res.data || [];
        }  catch (e) {
            console.log(e);
        }
    }
    // TODO 是否要tip
    onSearchFocus (e) {
        console.log('focus');
        let value: string = (this.$refs.input as HTMLInputElement).value.trim();
        this.showSearchSuggest = true;
        if (!value) {
            this.showlocalHistory = true;
        }
    }

    // 解决中文输入法问题
    onSearchInput (e) {!this.inputLock && this.triggerInput(e.target.value);}
    onSearchCompositionstart (e) {this.inputLock = true;}
    onSearchCompositionend (e) {this.inputLock = false;this.triggerInput(e.target.value);}
    triggerInput (str) {
        if(!str) {
            this.showlocalHistory = true;
            SearchStore.clearSearchList();
        } else {
            this.showlocalHistory = false;
        }
        SearchStore.searchCES(str);
        this.cur_line = null;
    }

    // 用户点击suggest item
    async sugClickHandler(item) {
        this.showlocalHistory = false;
        this.showSearchSuggest = false;
        this.searchValue = item.id;
        SearchStore.clearSearchList();
        SearchStore.setSearchItem(item);

        // TODO 复用
        let {subjectId, entityType} = this.searchData.searchItem;
        // 原来只有POI的样子
        // DetailStore.getPoiDataBySubjectId(subjectId);
        // DetailStore.getPoiGraph({subjectId});
        if (entityType === 'poi') {
            DetailStore.getPoiDataBySubjectId(subjectId);
            DetailStore.getPoiGraph({subjectId});
        } else if (entityType === 'user') {
            DetailStore.getUserDataBySubjectId(subjectId);
            DetailStore.getUserGraph({subjectId});
        }
    }

    async searchRequest(str, quick = false) {
        let searchRes = await SearchStore.searchCES(str, true, quick);
        if (this.detailData.access === 403 || !searchRes) {
            return void 0;
        }

        // TODO 复用
        // let {subjectId, entityType} = this.searchData.searchItem;
        let {subjectId, entityType} = searchRes;

        // 原来只有POI的样子
        // DetailStore.getPoiDataBySubjectId(subjectId);
        // DetailStore.getPoiGraph({subjectId});
        this.cur_line = null;

        if (entityType === 'user') {
            DetailStore.getUserDataBySubjectId(subjectId);
            DetailStore.getUserGraph({subjectId});
        } else if (entityType === 'poi') {
            DetailStore.getPoiDataBySubjectId(subjectId);
            DetailStore.getPoiGraph({subjectId});
        }
    }

    @Watch('historyList')
    async historyListChange (newVal: any, oldVal: any) {

        let lastItem = this.historyList.slice(0).pop();
        let lastItemName = lastItem.objectId || lastItem.name || lastItem.id;
        let searchItem = this.searchData.searchItem;

        if (lastItem.subjectId !== searchItem.subjectId ||
            this.searchValue !== lastItemName
        ) {
            SearchStore.setSearchItem(lastItem);
            this.searchValue = lastItemName;
        }
    }

    async onSearchHandler(e) {
        this.showlocalHistory = false;
        let value: string = (this.$refs.input as HTMLInputElement).value.trim();
        if (!value) {
            this.$message.error(this.lang.searchEmpty);
            return void 0;
        }
        await this.searchRequest(value, true);
    }
    changeCity (city) {
        this.searchValue = '';
        SearchStore.changeFilterCity(city);
        SearchStore.clearSearchList();
        SearchStore.suggest({
            str: (this.$refs.input as HTMLInputElement).value,
            city
        });
        this.cur_line = null;
        this.showCitySelect = false;
    }

    deleteLocalHistory(index) {
        SearchStore.deleteSearchHistory(index);
    }
    closeout () {
        $('body').click((e) => {
            if( !($( e.target ).closest('.search-inner').length || $( e.target ).closest('.search-city').length) ){
                SearchStore.clearSearchList();
                this.showlocalHistory = false;
                this.showCitySelect = false;
                this.showSearchSuggest = false;
            }
        });
    }
    beforeDestroy() {
         $('body').click(function() { return false; });
    }
    mounted() {
        let search_input = this.$refs.input as HTMLElement;
        search_input.onkeydown = async (ev) => {
            if (ev.keyCode === 13) { // enter键盘事件
                if (this.cur_line || this.cur_line === 0) {
                    if (this.showlocalHistory) {
                        this.sugClickHandler(this.searchData.searchHistoryList[this.cur_line]);
                    } else {
                        this.sugClickHandler(this.searchData.searchList[this.cur_line]);
                    }
                } else {
                    await this.onSearchHandler(ev);
                    SearchStore.clearSearchList();
                    this.showlocalHistory = false;
                }
            } else {
                let searchList = this.$refs.searchList as HTMLElement;
                if (!searchList) {
                    return;
                }
                let children = searchList.children;
                let cur_item  = searchList.querySelector('.item-active') as HTMLElement;
                if (ev.keyCode === 40) { //方向（下）键
                    if (!cur_item) {
                        children[0].className = 'search-item item-active';
                        cur_item = children[0] as HTMLElement;
                        this.cur_line = 0;
                    } else {
                        this.cur_line = cur_item.getAttribute('data-index');
                        cur_item.className = 'search-item';
                        if (cur_item.nextElementSibling) {
                            cur_item.nextElementSibling.className = 'search-item item-active';
                            this.cur_line++;
                            // console.log('cur_line', cur_line);
                        } else {
                            this.cur_line = 0;
                            children[this.cur_line].className = 'search-item item-active';
                        }
                    }
                }

                if (ev.keyCode === 38) { //方向（上）键
                    if (!cur_item) {
                            children[0].className = 'search-item item-active';
                            cur_item = children[0] as HTMLElement;
                            this.cur_line = 0;
                    } else {
                        this.cur_line = cur_item.getAttribute('data-index');
                        cur_item.className = 'search-item';
                        if (cur_item.previousElementSibling) {
                            cur_item.previousElementSibling.className = 'search-item item-active';
                            this.cur_line--;
                        } else {
                            this.cur_line = children.length - 1;
                            children[this.cur_line].className = 'search-item item-active';
                        }
                    }

                }

                // 关系公式：element.scrollHeight - element.scrollTop === element.clientHeight
                if (cur_item && cur_item.offsetTop >= searchList.offsetTop) {
                    console.log('cur_line', this.cur_line, children.length,  this.cur_line / (children.length - 1 ), cur_item.clientHeight);
                    searchList.scrollTop = searchList.scrollHeight * (this.cur_line  / (children.length - 1 )) - searchList.clientHeight + cur_item.clientHeight;
                    console.log(searchList.clientHeight,searchList.scrollTop, searchList.scrollHeight);
                    // searchList.scrollTop = searchList.scrollHeight;
                }
            }
        }
        this.closeout();
    }
}
